// Validación cliente. El regex E.164 duplica el del backend
// (src/features/access-requests/schemas.ts); mantenerlos en sync.
const E164_REGEX = /^\+[1-9]\d{1,14}$/;
const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export type AccessRequestFormInput = { email: string; phone: string };

export type FieldErrors = Partial<Record<keyof AccessRequestFormInput, string>>;

export function validateAccessRequest(input: AccessRequestFormInput): FieldErrors {
  const errors: FieldErrors = {};
  const email = input.email.trim().toLowerCase();
  if (!email) errors.email = "Ingresá tu email.";
  else if (!EMAIL_REGEX.test(email)) errors.email = "El email no parece válido.";

  const phone = input.phone.trim();
  if (!phone) errors.phone = "Ingresá tu teléfono.";
  else if (!E164_REGEX.test(phone))
    errors.phone = "Usá formato internacional. Ejemplo: +50688887777.";

  return errors;
}

export function validateEmailOnly(email: string): string | null {
  const trimmed = email.trim().toLowerCase();
  if (!trimmed) return "Ingresá tu email.";
  if (!EMAIL_REGEX.test(trimmed)) return "El email no parece válido.";
  return null;
}
